import { Component, OnInit, ViewChild, HostListener, ElementRef, EventEmitter, Input, AfterContentInit } from '@angular/core';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRest } from '../../login/login.rest';
import { IssuesRest } from '../issues.rest';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { GridMainFilter, SelectionMode, GridSelection, SortedColumn } from '../../core/shared/grid/grid.model';
import { Issue, IssueRow } from '../issues.model';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { IssuesChangeStateComponent } from './issues-change-state/issues-change-state.component';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { Permissions } from '../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { IssueService } from '../issue.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { DialogControl } from '../../core/shared/dialog/dialog.model';
import { DialogService } from '../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../core/shared/dialog/dialog-config';

const issueWatcherName = 'IssueWatcher';

@Component({
  selector: 'app-issues-list',
  templateUrl: './issues-list.component.html',
  styleUrls: ['./issues-list.component.scss']
})
export class IssuesListComponent extends GridSelection implements OnInit, DialogControl, GridParamsRestorable {
  readonly detailsPath: string = '/issues/issue';

  public permissions: Permissions;

  public dialogConfigData: any;
  public onDialogClose: EventEmitter<any> = new EventEmitter<any>();
  public confirmDialog() { };
  public closeDialog() { };
  isConfirmButtonDisabled: boolean;

  @Input() initialFilters: any;
  @Input() lockInitialFilters = false;
  @Input() customerId: number;
  @Input() tfsOnly: number;
  @ViewChild(GridComponent) grid: GridComponent;
  private path: string;
  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;
  public viewEnable = true;
  public assignedToSelect: ObjectToSelect[];
  public watchersToSelect: ObjectToSelect[];
  public customersToSelect: ObjectToSelect[];
  public stateToSelect: ObjectToSelect[];
  public hideToggles: boolean;
  public expanded: boolean;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public previousMainFilters: any = {};
  public editedItemId: number;
  public projectStepId: number;
  private mainFilter: GridMainFilter[];
  private currentUser: any;
  private isClosed: boolean;
  private isNotAssigned: boolean;
  private assignedId: number;
  private assignedCode: string;
  private watcherCode: string;
  private customerIds: number[];
  private states: string[];
  private isRestoredMainFilter: boolean = false;
  private vstsOptions: ObjectToSelect[];
  private withRestoring = true;
  private isModal = false;

  private headers = [
    { displayName: 'Tytuł', propertyName: 'fullTitle', propertyType: 'string' },
    { displayName: 'Zmieniono', propertyName: 'updatedDate', propertyType: 'date', isInitSort: true, dateFormat: 'dd.MM.yyyy HH:mm' },
    { displayName: 'Zgłoszono', propertyName: 'createdDate', propertyType: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { displayName: 'Kontrahent', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Etap', propertyName: 'projectFullName', propertyType: 'string' },
    { displayName: 'Zgłaszający', propertyName: 'reporterName', propertyType: 'string' },
    { displayName: 'Przypisany', propertyName: 'elementAssignee', propertyType: 'string' },
    { displayName: 'Odpowiedzialny', propertyName: 'assigneeName', propertyType: 'string' },
    { displayName: 'Autor', propertyName: 'author', propertyType: 'string' },
    { displayName: 'Status', propertyName: 'issueState', propertyType: 'string' },
    { displayName: 'Vsts Id', propertyName: 'tfsId', propertyType: 'number' },
    { displayName: 'Typ', propertyName: 'issueType', propertyType: 'string' }
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'Kopiuj', class: "btn-success", icon: '', onClick: () => { this.copy() }, enabled: true, isForSelected: true },
    { text: 'Zmiana statusu', class: "btn-primary", icon: '', onClick: () => { this.changeState() }, enabled: true, isForSelected: true }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginRest: LoginRest,
    private issueRest: IssuesRest,
    public dialog: DialogService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private issueService: IssueService,
    private permissionService: PermissionsService
  ) {
    super();
    this._grid = this.grid;
    this.onResize();
  }

  ngOnInit() {
    this.mainFilter = new Array();
    this.spinnerService.show();
    if (!this.dialogConfigData) {
      this.tryRestoreFiltersAndPage();
    }
    this.getUsersToSelect();
    this.getStatesToSelect();
    this.getCustomersToSelect();
    this.initializeVstsFilter();
    this.setPermissions('Issue');
    this.path = `api/issues/grid`;

    this.selectionMode = this.selectionMode === SelectionMode.none ? SelectionMode.multi : this.selectionMode;

    this.isClosed = false;
    this.processDialogConfig();
  }

  ngAfterViewInit() {
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
    this.isEditable = this.selectionMode === SelectionMode.none && (this.permissions.canEdit || this.permissions.canShow);
    this.isRemovable = this.selectionMode === SelectionMode.none && this.permissions.canDelete;
    this.isAdd = this.selectionMode === SelectionMode.none && this.permissions.canAdd;
    if (this.permissions.hasIssuesNotAssignedPermission && this.previousMainFilters.NotAssignedIssue == null) {
      this.isNotAssigned = true;
      this.mainFilter.push({ internalName: 'NotAssignedIssue', value: 'true' });
    }
  }

  private processDialogConfig() {
    if (!this.dialogConfigData) {
      return;
    }
    if (this.dialogConfigData['initialFilters']) {
      this.initialFilters = this.dialogConfigData['initialFilters'];
      this.lockInitialFilters = this.dialogConfigData['lockInitialFilters'];
    }
    if (this.dialogConfigData['customerId']) {
      this.customerId = this.dialogConfigData['customerId'];
      this.mainFilter.push({ internalName: 'CustomerId', value: this.customerId.toString() });
    }
    if (this.dialogConfigData['tfsOnly']) {
      this.tfsOnly = this.dialogConfigData['tfsOnly'];
      this.mainFilter.push({ internalName: 'TfsOnly', value: this.tfsOnly.toString() });
    }
    if (this.dialogConfigData['projectStepId']) {
      this.projectStepId = this.dialogConfigData['projectStepId'];
      this.mainFilter.push({ internalName: 'ProjectStepId', value: this.projectStepId.toString() });
    }
    this.withRestoring = false;
    this.isModal = true;
  }

  public getUsersToSelect() {
    const action = this.issueRest.getAssignedToSelect;
    action.call(this.issueRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.assignedToSelect = result.sort((x, y) => x.name > y.name ? 1 : -1);
        this.watchersToSelect = result.sort((x, y) => x.name > y.name ? 1 : -1);
        this.watcherCode = null;

        this.getCurrentUser();
      }
    });
  }

  public getCustomersToSelect() {
    const action = this.issueRest.getCustomerIdsToSelect;
    action.call(this.issueRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.customersToSelect = result.sort((x, y) => x.name > y.name ? 1 : -1);
        this.customerIds = undefined;
      }
    });
  }

  public getStatesToSelect() {
    const action = this.issueRest.getStates;
    action.call(this.issueRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.stateToSelect = result.sort((x, y) => x.name > y.name ? 1 : -1);
        this.states = undefined;
      }
    });
  }

  private getCurrentUser() {
    if (!this.isRestoredMainFilter) {
      this.spinnerService.show();
    }
    this.loginRest.GetLoggedUser().subscribe((user: any) => {
      this.currentUser = user;
      
      const assigned = this.assignedToSelect.find(x => x.id === this.assignedId);
      if(assigned)
      {
        this.assignedId = user.employeeId;
        this.assignedCode = user.email;
      }
      this.spinnerService.hide();
    });
  }

  private initializeVstsFilter() {
    this.vstsOptions = [
      { id: 0, name: 'Nie', guid: '' },
      { id: 1, name: 'Tak', guid: '' }
    ];
  }

  private setFilter(internalName: string, value: any) {
    this.mainFilter.push({ internalName: internalName, value: value });
    this.grid.mainFilter = this.mainFilter;
  }

  private filter() {
    this.mainFilter = new Array();
    if (this.projectStepId != undefined) {
      this.setFilter('ProjectStepId', this.projectStepId);
    } else {
      if (this.assignedId !== undefined) {
        this.setFilter('IssueAssigned', this.assignedId);
        if (this.assignedId) {
          this.setFilter('IssueAssignedCode', this.assignedToSelect.find(x => x.id === this.assignedId).guid);
        } else {

        }
      }

      if (this.watcherCode !== undefined) {
        this.setFilter('IssueWatcher', this.watcherCode);
      }

      if (this.states !== undefined) {
        this.setFilter('ObjectStates', this.mergeStringArray(this.states))
      }
      
      if (this.customerIds !== undefined) {
        this.setFilter('CustomerIds', this.mergeNumberArray(this.customerIds))
      }

      this.setFilter('ClosedIssue', this.isClosed);
      this.setFilter('NotAssignedIssue', this.isNotAssigned);
    }

    if (this.customerId != null) {
      this.setFilter('CustomerId', this.customerId);
    }

    if (this.tfsOnly != null) {
      this.setFilter('TfsOnly', this.tfsOnly);
    }
    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  private mergeStringArray(array: string[]) {    
    return array.join(",");
  }

  private mergeNumberArray(array: number[]) {    
    return array.join(",");
  }

  private clearFilter() {
    if (this.assignedId !== this.currentUser.employeeId || this.watcherCode !== undefined
      || this.isClosed !== false || this.isNotAssigned !== false || this.tfsOnly != null) {
      
      if(this.assignedToSelect.find(x => x.id === this.currentUser.employeeId))
      {
        this.assignedId = this.currentUser.employeeId;
        this.assignedCode = this.currentUser.email;
      }
      else
      {
        this.assignedId = null;
        this.assignedCode = null;
      }
      this.watcherCode = undefined;
      this.customerIds = undefined;
      this.states = undefined;
      this.isNotAssigned = this.permissions.hasIssuesNotAssignedPermission;
      this.isClosed = false;
      this.tfsOnly = null;
      this.filter();
    }
  }

  private onRowEdit(row: IssueRow) {
    this.issueService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../issues/issue', row.id], { queryParams: { id: row.id }, relativeTo: this.route });
  }

  private changeState() {
    var selectedItems = this.grid.getSelectedItems();

    if (selectedItems.length === 0) {
      sweetAlert("Nie zaznaczono elementów.");
      return;
    }

    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.none;
    dialogConf.title = 'Wybierz status';
    dialogConf.maxwidth = '700px';
    dialogConf.data = { selectedItems: selectedItems.map(u => u.id) };

    const dialogRef = this.dialog.open(IssuesChangeStateComponent, dialogConf);
    dialogRef.afterClosed.subscribe(() => this.grid.refreshData());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {

    if (window.innerWidth <= 769) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

  private onRowAdd() {
    this.issueService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../issues/issue', 'new'], { queryParams: { id: 0 }, relativeTo: this.route });
  }

  private onRowDelete(row: IssueRow) {
    sweetAlert('Czy na pewno chcesz usunąć zgłoszenie?', {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            const action = this.issueRest.checkIfIssueHasElements;
            action.call(this.issueRest, row.id).subscribe((result: boolean) => {
              if (result === true) {
                let message = `Zgłoszenie posiada elementy. Czy na pewno chcesz je usunąć?`;

                sweetAlert(message, {
                  buttons: {
                    yes: {
                      text: "Tak",
                      value: "yes"
                    },
                    no: {
                      text: "Nie",
                      value: "no",
                    }
                  }
                })
                  .then((value) => {
                    switch (value) {
                      case "yes":
                        this.deleteIssue(row.id);
                        break;
                    }
                  });
              } else {
                this.deleteIssue(row.id);
              }
            });
            break;
        }
      });
  }

  private deleteIssue(id: number) {
    const action = this.issueRest.removeIssue;
    action.call(this.issueRest, id).subscribe((result: string) => {
      if (result) {
        sweetAlert({ text: `Usunięto zgłoszenie` });
        this.grid.refreshData(false);
      }
    });
  }

  private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }
    this.initialFilters = previousGridParams.initialFilters;
    this.previousMainFilters = previousGridParams.previousMainFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
  }

  private copy() {
    var selectedItems = this.grid.getSelectedItems();

    if (selectedItems.length == 0) {
      sweetAlert("Nie zaznaczono elementu.");
      return;
    }

    if (selectedItems.length > 1) {
      sweetAlert("Zaznaczono więcej niż jeden element.");
      return;
    }

    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, selectedItems[0].id);
    this.router.navigate(['../issues/issue', 'copy', selectedItems[0].id], { queryParams: { isCopy: 1, id: selectedItems[0].id }, relativeTo: this.route });
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  private setFiltersFromRestoredData() {
    const isClosed = this.findFilter('ClosedIssue');
    if (isClosed != null && isClosed === 'true') {
      this.isClosed = true;
    } else if (isClosed != null && isClosed === 'false') {
      this.isClosed = false;
    } else {
      this.isClosed = this.isClosed;
    }

    const tfsOnly = this.findFilter('TfsOnly');
    this.tfsOnly = tfsOnly != null ? parseInt(tfsOnly) : null;

    const assignedId = this.findFilter('IssueAssigned');
    this.assignedId = assignedId != null ? parseInt(assignedId) : null;

    if (this.assignedId) {
      const assignedCode = this.findFilter('IssueAssignedCode');
      this.assignedCode = assignedCode != null ? assignedCode : null;
    } else {
      this.assignedCode = null;
    }

    const watcherCode = this.findFilter('IssueWatcher');
    this.watcherCode = watcherCode;

    const customerIds = this.findFilter('CustomerIds');
    this.customerIds = customerIds != null ? customerIds.split(',').map(id => parseInt(id)) : undefined;

    const states = this.findFilter('ObjectStates');
    this.states = states != null ? states.split(',') : undefined;

    const isNotAssigned = this.findFilter('NotAssignedIssue');
    if (isNotAssigned != null && isNotAssigned === 'true') {
      this.isNotAssigned = true;
    } else if (isNotAssigned != null && isNotAssigned === 'false') {
      this.isNotAssigned = false;
    } else {
      this.isNotAssigned = this.isNotAssigned;
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }
}
